module.exports = __webpack_public_path__ + "img/master-card.97f9bf95.png";